import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
  validateButton: {
    width: 110,
    height: 34,
    textTransform: 'none',
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '18px',
    backgroundColor: '#DF0C36',
    marginBottom: 16,
    marginRight: 16,
    borderRadius: 0,
    '&:hover': {
      backgroundColor: '#B00429',
    },
  },
  dialogText: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '14px',
    lineHeight: '20px',
    color: '#333333',
  },
  loader: {
    color: '#DF0C36',
    position: 'fixed',
    left: '50%',
    top: '50%',
  },
  paper: {
    maxWidth: '824px',
    minWidth: '600px',
    width: '60%',
    marginTop: '90px',
    marginBottom: '2%',
  },
  EmailIcon: {
    color: '#DF0C36',
    margin: '30px 30px',
  },
  dialogTitle: {
    marginTop: '10px',
  },
  title: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '28px',
    lineHeight: '36px',
    color: '#666666',
    margin: '0 !important',
  },
  subTitle: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '20px',
    lineHeight: '28px',
    color: '#333333',
  },
  closeIcon: {
    padding: '0 !important',
    marginTop: '25px !important',
  },
  formLabel: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '20px',
    marginBottom: '5px',
  },
  input: {
    marginTop: '5px',
    marginBottom: '10px',
    width: '100%',
  },
  inputStyle: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '12px',
    lineHeight: '20px',
  },
}));
